<template>
  <AppNavbar />
  <div class="d-flex flex-column ecommerce-layout">
    <AppHeader title="Ecommerce" class="header-compact px-4 border-bottom">
      <template #buttons>
        <button
          v-if="showBackButton"
          type="button"
          class="btn btn-outline-secondary ecommerce-back-button"
          @click="goBack"
        >
          <i class="bi bi-arrow-left"></i>
          Volver
        </button>
      </template>
    </AppHeader>
    <div class="d-flex flex-grow-1">
      <aside class="sidebar p-3">
        <ul class="nav flex-column gap-1">
          <li v-for="item in visibleMenu" :key="item.name" class="nav-item">
            <router-link class="nav-link" :to="item.to" exact-active-class="active">
              <i :class="item.icon + ' me-2'"></i>{{ item.label }}
            </router-link>
          </li>
        </ul>
      </aside>
      <main class="flex-fill p-4">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppNavbar from '@/components/AppNavbar.vue'
import { hasPermission } from '@/services/authSessionService'

// Sección propia de Ecommerce (RF-2 de SPEC_CONSULTORIA_negocio_v0.1.md,
// en ecommerce-graciela/docs). Antes esta configuración vivía dentro de
// Mantenimiento, mezclada con balanzas, cajas, fiscal y jobs. Para un
// negocio donde el ecommerce es el canal principal de venta —y no un
// accesorio del mostrador— dejó de tener sentido tenerla ahí adentro.
//
// Mismo patrón estructural que MaintenanceLayout y ReportesLayout: no se
// inventa una navegación nueva, se replica la que el POS ya usa.
export default {
  name: 'EcommerceLayout',
  components: {
    AppHeader,
    AppNavbar
  },
  data() {
    return {
      menu: [
        { name: 'ecommerce-home', label: 'Resumen', to: { name: 'EcommerceHome' }, icon: 'bi bi-grid-1x2', permiso: null },
        { name: 'ecommerce-config', label: 'Configuración', to: { name: 'EcommerceConfiguracion' }, icon: 'bi bi-shop', permiso: 'gestionar_ecommerce' },
        { name: 'ecommerce-mensajes', label: 'Mensajes y avisos', to: { name: 'EcommerceMensajes' }, icon: 'bi bi-whatsapp', permiso: 'gestionar_ecommerce' },
        { name: 'ecommerce-imagenes', label: 'Catálogo e imágenes', to: { name: 'EcommerceImagenes' }, icon: 'bi bi-images', permiso: 'editar_productos' }
      ]
    }
  },
  computed: {
    visibleMenu() {
      return this.menu.filter((item) => !item.permiso || hasPermission(item.permiso))
    },
    showBackButton() {
      return this.$route?.name && this.$route.name !== 'EcommerceHome'
    }
  },
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.back()
        return
      }
      this.$router.push({ name: 'EcommerceHome' })
    }
  }
}
</script>

<style scoped>
.ecommerce-layout {
  min-height: 100vh;
}

.header-compact {
  padding-top: .5rem;
  padding-bottom: .5rem;
}

.sidebar {
  width: 260px;
  background: #fff;
  border-right: 1px solid #e5e5e5;
}

.ecommerce-back-button {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
}

.sidebar .nav-link {
  color: #111;
  border-radius: .25rem;
  padding: .6rem .9rem;
}

.sidebar .nav-link:hover {
  background: #f2f2f2;
  color: #111;
}

.sidebar .nav-link.active {
  background: #111;
  color: #fff;
  font-weight: 600;
}

main {
  background: #f9f9f9;
  overflow-y: auto;
}
</style>
